import React, { ReactElement } from 'react';
import { Row } from '@tanstack/react-table';
import * as DataTableTypes from './utils/DataTableTypes';
import { Tr } from './DataTableBasicElements/Tr';
import { DataTableCell } from './DataTableCell';

interface Props<D extends object = {}> {
  row: Row<D> | undefined;
  isSelected: boolean;
  border: DataTableTypes.DataTableBorder | undefined;
  rowHeight: DataTableTypes.DataTableRowHeight | undefined;
  firstVisibleColumn: string | undefined;
  resizeTableColumns: boolean;
}

export const DataTableRow = <D extends object = {}>({
  border,
  row,
  rowHeight,
  firstVisibleColumn,
  isSelected,
  resizeTableColumns
}: Props<D>): ReactElement | null => {
  // return a loader if row is undefined
  if (!row)
    return (
      <Tr
        resizeTableColumns={resizeTableColumns}
        dataTest={undefined}
        isSkeleton={false}
        isSelected={false}
        rowHeight={rowHeight}
      />
    );
  return (
    <Tr
      resizeTableColumns={resizeTableColumns}
      role="row"
      dataTest={undefined}
      isSkeleton={false}
      rowHeight={rowHeight}
      isSelected={isSelected}
    >
      {row.getVisibleCells?.().map((cell, index) => (
        <DataTableCell<D, unknown>
          resizeTableColumns={resizeTableColumns}
          firstVisibleColumn={firstVisibleColumn}
          border={border}
          rowOriginal={row.original}
          cell={cell}
          columnId={cell.column.id}
          key={(cell?.id ?? '') + index.toString()}
        />
      ))}
    </Tr>
  );
};
